<template>
    <div class="container pt-2">
        <PageTitle icon="fa fa-address-card" main="Extrato de Transações" sub="Lista de movimentações das Transações" />
        <div class="row">
            <div class="col-md-3 divisoria divisoria-borda">
                Saldo Total: <br><money class="no-border" disabled v-model="saldoTotal" v-bind="money"></money>
            </div>
            <div class="col-md-3 divisoria divisoria-borda">
                Saldo Liberado: <br><money class="no-border" disabled v-model="saldoLiberado" v-bind="money"></money>
            </div>
            <div class="col-md-3 divisoria">
            </div>
            <div class="col-md-3 divisoria">
            </div>
        </div>
        <hr>
        <div :style="{ overflow: overflowValue, width: larguraTela + 'px' }" v-if="larguraTela<721">
            <b-table hover small striped class="text-center align-middle table" :items="extratos" :fields="fields">
                <template v-slot:cell(template_credito)="data">
                    <span v-if="data.item.liberado!=='sim'" class="text-success text-strike-success"><b>{{ data.item.tipo==='credito' ? formatMoney(data.item.valor) : '' }}</b></span>
                    <span v-else class="text-success">{{ data.item.tipo==='credito' ? formatMoney(data.item.valor) : '' }}</span>
                </template>
                <template v-slot:cell(template_debito)="data">
                    <span v-if="data.item.liberado!=='sim'" class="text-danger text-strike-danger"><b>{{ data.item.tipo==='debito' ? formatMoney(data.item.valor) : '' }}</b></span>
                    <span v-else class="text-danger">{{ data.item.tipo==='debito' ? formatMoney(data.item.valor) : '' }}</span>
                </template>
            </b-table>
        </div>
        <div v-else>
            <b-table hover small striped class="text-center align-middle table" :items="extratos" :fields="fields">
                <template v-slot:cell(template_credito)="data">
                    <span v-if="data.item.liberado!=='sim'" class="text-success text-strike-success"><b>{{ data.item.tipo==='credito' ? formatMoney(data.item.valor) : '' }}</b></span>
                    <span v-else class="text-success">{{ data.item.tipo==='credito' ? formatMoney(data.item.valor) : '' }}</span>
                </template>
                <template v-slot:cell(template_debito)="data">
                    <span v-if="data.item.liberado!=='sim'" class="text-danger text-strike-danger"><b>{{ data.item.tipo==='debito' ? formatMoney(data.item.valor) : '' }}</b></span>
                    <span v-else class="text-danger">{{ data.item.tipo==='debito' ? formatMoney(data.item.valor) : '' }}</span>
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'
import { VueEasyJwt } from 'vue-easy-jwt'
import { VMoney } from 'v-money'

export default {
    name: 'extrato',
    components: { PageTitle },
    directives: { money: VMoney },
    data: function() {
        return {
            jwt: new VueEasyJwt(),
            nivel: '',
            extrato: {},
            extratos: [],
            valor: {},
            valores: [],
            quemRecebeu: '',
            saldoTotal: '',
            saldoLiberado: '',
            creditoTotal: '',
            creditoLiberado: '',
            fields: [
                { key: 'data_atualizacao', label: 'Data', formatter: 'formatData' },
                { key: 'status', label: 'Status' },
                { key: 'id_job_numero', label: 'Processo' },
                { key: 'template_credito', label: 'Crédito' },
                { key: 'template_debito', label: 'Débito' }
            ],
            larguraTela: 0,
            overflowValue: 'auto',
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            }
        }
    },
    methods: {
        formatData(value) {
            const arr = value.split('-')
            const y = arr[0]
            const m = arr[1]
            const d = arr[2]
            return `${d}/${m}/${y}`
        },
        formatMoney(value) {
            if(value.indexOf('.') > -1) {
                const arr = value.split('.')
                const r = arr[0]
                const c = arr[1]
                if(c.length < 2) {
                    return `R$${r},${c}0`
                } else {
                    const c1 = arr[1].charAt(0)
                    const c2 = arr[1].charAt(1)
                    return `R$${r},${c1}${c2}`
                }
            } else {
                return `R$${value},00`
            }
        },
        loadExtratos() {
            const url = `${baseApiUrl}/backend/SELECT/extratoEmpresa.php?colaborador=${this.quemRecebeu}&nivel=${this.nivel}`
            axios.get(url).then(res => {
                this.extratos = res.data
            })
        },
        loadValores() {
            const url = `${baseApiUrl}/backend/GENERAL/valores.php?colaborador=999`
            axios.get(url).then(res => {
                this.valores = res.data
                this.creditoTotal = 
                    (parseFloat(this.valores[0].creditoLiberado) > 0 ? parseFloat(this.valores[0].creditoLiberado) : 0)
                    + 
                    (parseFloat(this.valores[0].creditoBloqueado) > 0 ? parseFloat(this.valores[0].creditoBloqueado) : 0)
                this.creditoLiberado = 
                    (parseFloat(this.valores[0].creditoLiberado) > 0 ? parseFloat(this.valores[0].creditoLiberado) : 0)
                this.saldoTotal = 
                    this.creditoTotal 
                    - 
                    (parseFloat(this.valores[2].debito) > 0 ? parseFloat(this.valores[2].debito) : 0)
                this.saldoLiberado = 
                    this.creditoLiberado 
                    - 
                    (parseFloat(this.valores[2].debito) > 0 ? parseFloat(this.valores[2].debito) : 0)
            })
        },
        loadExtrato(extrato) {
            this.extrato = { ...extrato }
        },
        validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
                this.$router.push({ path: '/login' })
            } else {
                this.nivel = decodedToken['data'].nivel
                this.quemRecebeu = decodedToken['data'].id
            }
        }
    },
    mounted() {
        this.validaLogin()
        this.loadExtratos()
        this.loadValores()
        this.larguraTela = screen.width - (screen.width * 0.08)

    }
}
</script>

<style>

.table {
    font-size: 0.9rem;
}

.text-strike-success {
    text-decoration: rgb(31, 129, 54) line-through;
}

.text-strike-danger {
    text-decoration: rgb(170, 42, 54) line-through;
}

.divisoria {
    line-height:30px;
    text-align: center;
    font-style: italic;
}
.divisoria-borda {
    border-right: 1px solid rgb(199, 199, 199);
}

.no-border {
    border: 0;
    text-align: center;
    font-style: italic;
}

</style>